<template>
    <div>
        <div class="uk-grid uk-grid-small uk-grid-width-1-3 uk-margin-bottom">
            <div>
                <ul class="uk-subnav uk-subnav-line">
                    <li class="uk-disabled"><a href="">Sort</a></li>
                    <li :class="{'uk-active': state.sort_by === 'sortable_number'}"><a href @click.prevent="set_state_values({ sort_by: 'sortable_number', sort_dir: 'desc' })">Project Number</a></li>
                    <li :class="{'uk-active': state.sort_by === 'computed_sortable_current_phase'}"><a href @click.prevent="set_state_values({ sort_by: 'computed_sortable_current_phase', sort_dir: 'asc' })">Phases</a></li>
                </ul>
                <!--
                <ul class="uk-subnav uk-subnav-line">
                    <li :class="{'uk-active': !state.filter}"><a href @click.prevent="set_state_value('filter', '')">All</a></li>
                    <li :class="{'uk-active': state.filter === 'Active'}"><a href @click.prevent="set_state_value('filter', 'Active')">Active</a></li>
                    <li :class="{'uk-active': state.filter === 'On Hold'}"><a href @click.prevent="set_state_value('filter', 'On Hold')">On Hold</a></li>
                    <li :class="{'uk-active': state.filter === 'Completed'}"><a href @click.prevent="set_state_value('filter', 'Completed')">Completed</a></li>
                    <li :class="{'uk-active': state.filter === 'Dead'}"><a href @click.prevent="set_state_value('filter', 'Dead')">Dead</a></li>
                </ul>
                //-->
            </div>
            <form @submit.prevent.stop class="uk-form uk-text-center">
                <form-select-user
                    id="calendar-user-filter"
                    name="user_id"
                    :value="state.user_id"
                    :editable="true"
                    empty-label="(All)"
                    :empty-value="0"
                    :required="false"
                    class="uk-width-1-5"
                    style="margin: 0 auto;"
                    @input="set_state_value('user_id', $event)"
                />
            </form>
            <div class="uk-text-right">
                <div class="uk-button-group lam-graph-filter">
                    <!--
                    <base-button
                        size="mini"
                        :class="{'uk-active': state.scope === 6}"
                        @click.prevent="set_state_value('scope', 6)"
                    >
                        6 weeks
                    </base-button>
                    <base-button
                        size="mini"
                        :class="{'uk-active': state.scope === 13}"
                        @click.prevent="set_state_value('scope', 13)"
                    >
                        3 months
                    </base-button>
                    //-->
                    <base-button
                        size="mini"
                        :class="{'uk-active': state.scope === 26}"
                        @click.prevent="set_state_value('scope', 26)"
                    >
                        6 months
                    </base-button>
                    <base-button
                        size="mini"
                        :class="{'uk-active': state.scope === 52}"
                        @click.prevent="set_state_value('scope', 52)"
                    >
                        1 year
                    </base-button>
                    <base-button
                        size="mini"
                        :class="{'uk-active': state.scope === 104}"
                        @click.prevent="set_state_value('scope', 104)"
                    >
                        2 years
                    </base-button>
                </div>
            </div>
        </div>

        <linear-calendar
            v-if="profile_id"
            :user-id="state.user_id"
            :current-status-filter="state.filter"
            :current-sort="state.sort_by"
            :current-sort-dir="state.sort_dir"
            :date-range="state.scope"
        />
    </div>
</template>

<script>
import handles_stored_state from "../../mixins/HandlesStoredState"
import profile_utilities from "../../mixins/ProfileUtilities"

import FormSelectUser from "../../ui/FormSelectUser"
import BaseButton from "../../ui/BaseButton"
import LinearCalendar from "../../ui/LinearCalendar"

export default {
    mixins: [handles_stored_state, profile_utilities],
    components: {
        FormSelectUser,
        BaseButton,
        LinearCalendar
    },
    mounted () {
        this.load()
    },
    watch: {
        $route: "load",
        profile_id: "load"
    },
    methods: {
        load () {
            if(this.profile_id) this.set_state_value("user_id", this.profile_id)
        }
    },
    data () {
        return {
            default_state: {
                scope: 52, // nb_weeks
                filter: "Active",
                sort_by: "computed_sortable_current_phase",
                sort_dir: "asc",
                user_id: -1
            }
        }
    }
}
</script>
